import { render, staticRenderFns } from "./Report104.vue?vue&type=template&id=36872fea"
import script from "./Report104.vue?vue&type=script&lang=js"
export * from "./Report104.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports